module.exports = __webpack_public_path__ + "static/media/logo_new.84c3d380.png";